import { useCanvasSkus } from '@/hooks/canvas/useCanvasSkus';
import CompactPagination from '../commos/CompactPagination';
import CanvasThumbnailGrid from './CanvasThumbnailGrid';

const CanvasSkusTab = ({ search }: { search: string }) => {
  const { skus, isLoading, error, page, totalPages, setPage } = useCanvasSkus(search);

  const renderList = () => {
    if (isLoading) return <p className="text-sm text-gray-500">Cargando SKUs...</p>;
    if (error) return <p className="text-sm text-red-600">{error}</p>;
    if (skus.length === 0) return <p className="text-sm text-gray-500">No se encontraron SKUs.</p>;
    return <CanvasThumbnailGrid kind="sku" items={skus.map((s) => ({ id: s.id, url: s.url, alt: s.name, dragUrl: s.fullUrl }))} />;
  };

  return (
    <div className="flex flex-col gap-4">
      {renderList()}
      <CompactPagination page={page} totalPages={error ? 0 : totalPages} onChangePage={setPage} />
    </div>
  );
};

export default CanvasSkusTab;
